import { Building, Person } from '@/shared/icons/outline'
import { Icon } from '@/types/global'

import { EntityType, Recipient } from '../features/Recipients/types'

export const iconByRecipientType: Record<Recipient['entityType'], Icon> = {
  [EntityType.BUSINESS]: Building,
  [EntityType.INDIVIDUAL]: Person,
}
